// extracted by mini-css-extract-plugin
export default {"wrapper":"LoadingSpinnerOverlay_wrapper__-5gu2","spinner":"LoadingSpinnerOverlay_spinner__RQ3co"};